export function convertToBase64(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    //TODO
    //Try sending the above 'file' to REACH photos sync endpoint
    // turn to buffer
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
}

// const MongoClient = require("mongodb").MongoClient;
// const fs = require("fs");

// async function getBase64FromMongoDB(url, dbName, collectionName, query) {
//   const client = new MongoClient(url, {
//     useNewUrlParser: true,
//     useUnifiedTopology: true,
//   });
//   await client.connect();
//   const collection = client.db(dbName).collection(collectionName);
//   const document = await collection.findOne(query);
//   await client.close();
//   return document.base64Field; // replace 'base64Field' with the actual field name
// }

// async function convertBase64ToFile(base64String) {
//   const buffer = Buffer.from(base64String, "base64");
//   fs.writeFileSync("photo.jpg", buffer); // replace 'photo.jpg' with your actual file name
// }

// async function main() {
//   const base64String = await getBase64FromMongoDB(
//     "mongodb://localhost:27017/",
//     "mydatabase",
//     "mycollection",
//     { _id: "some_id" }
//   ); // replace with your actual query
//   await convertBase64ToFile(base64String);

//   // Now you can use 'photo.jpg' with the `DoBulkPhotoUpload` function
// }

// main().catch(console.error);
